import { createAction } from '@reduxjs/toolkit';

import { LayoutActions } from './constants';

export const setSidebarVisibility = createAction<boolean>(LayoutActions.SET_SIDEBAR_VISIBILITY);

export const setUnPurchasedModalVisibility = createAction<boolean>(LayoutActions.SET_UNPURCHASED_MODAL_VISIBILITY);
